/**
 * Notice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SimpleEvent model module.
 * @module model/SimpleEvent
 * @version 1.0
 */
class SimpleEvent {
    /**
     * Constructs a new <code>SimpleEvent</code>.
     * @alias module:model/SimpleEvent
     */
    constructor() { 
        
        SimpleEvent.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SimpleEvent</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SimpleEvent} obj Optional instance to populate.
     * @return {module:model/SimpleEvent} The populated <code>SimpleEvent</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SimpleEvent();

            if (data.hasOwnProperty('uuid')) {
                obj['uuid'] = ApiClient.convertToType(data['uuid'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('start_at')) {
                obj['start_at'] = ApiClient.convertToType(data['start_at'], 'String');
            }
            if (data.hasOwnProperty('is_running')) {
                obj['is_running'] = ApiClient.convertToType(data['is_running'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * Uuid of the event
 * @member {String} uuid
 */
SimpleEvent.prototype['uuid'] = undefined;

/**
 * Name of the event
 * @member {String} name
 */
SimpleEvent.prototype['name'] = undefined;

/**
 * Start date of the event
 * @member {String} start_at
 */
SimpleEvent.prototype['start_at'] = undefined;

/**
 * Marks if event is online
 * @member {Number} is_running
 */
SimpleEvent.prototype['is_running'] = undefined;






export default SimpleEvent;

